import { useAppContext } from "@/src/config/AppProvider";

export default function useRandomQuote() {
  const { getThinkerWords } = useAppContext();
  const quotes = getThinkerWords();

  const randomIndex = Math.floor(Math.random() * quotes.length);

  const getRandomQuote = () => {
    return quotes[randomIndex];
  };

  return { getRandomQuote };
}
